import { WordModel } from './Word';

export * from './Word';
export const wordStore = new WordModel();
